const KEY = "cockpit.recentPatients";
const MAX = 5;

export interface RecentPatient {
  patientId: string;
  /** The patient's display name, when known at record time (falls back to id). */
  name?: string;
  lastAccessedAt: string; // ISO 8601
}

export function getRecentPatients(): RecentPatient[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as RecentPatient[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return []; // swallow quota / parse errors (private browsing)
  }
}

export function recordRecentPatient(patientId: string, name?: string): void {
  const now = new Date().toISOString();
  const existing = getRecentPatients();
  const deduped = existing.filter((p) => p.patientId !== patientId);
  // A provided name sets/updates it; an absent/blank name preserves any name
  // already stored for this patient, so an id-only re-record (deep link,
  // refresh) does not erase a previously-captured display name.
  const resolvedName =
    name?.trim() ||
    existing.find((p) => p.patientId === patientId)?.name?.trim();
  const entry: RecentPatient = resolvedName
    ? { patientId, name: resolvedName, lastAccessedAt: now }
    : { patientId, lastAccessedAt: now };
  const next: RecentPatient[] = [entry, ...deduped].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new Event("storage"));
  } catch {
    // ignore quota errors
  }
}
